export const getHeightAndWidth = (size?: "sm" | "md" | "lg") => {
  switch (size) {
    case "sm":
      return ""
    case "md":
      return 46
    case "lg":
      return 80
    default:
      return 46
  }
}
